// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"514":"b719c71d","529":"b604e9c6","881":"cb692ba3","982":"b604e9c6"}[chunkId] + ".chunk.css";
};